module.exports = __webpack_public_path__ + "static/img/Kindle_Paperwhite4.5b581b6e.jpg";